import React from 'react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import RenderValidateMessage from '../../../stories/Validation/RenderValidateMessage'

import { CKEditor } from '@ckeditor/ckeditor5-react';
import { UtilityStepHeader } from '@axshealth/design-library'
import { Card, Row, Col, Button, Alert } from 'react-bootstrap'

import './style.css'

const CURRENT_STEP = 'BIOGRAPHY';

const stepColor = {
  icon: {
    current: '#17A2B8',
    complete: '#4CDC6C',
    incomplete: '#D8D8D8',
  },
  text: {
    current: '',
    complete: '',
    incomplete: '#6F6F6F',
  }
};

export default function Biography({
  bio,
  step,
  steps,
  errors,
  setValue,
  stepBack,
  stepForward,
}) {

  if (step !== CURRENT_STEP) {
    return null
  }

  return <Row>
    <Col className='px-0'>
      <Card>
        <Card.Body>
          <UtilityStepHeader steps={steps} stepColor={stepColor} />

          <Row>
            <Col xs='12' className="mt-3 mb-4">
              <Alert variant='primary'>
                Let your patients know more about yourself.
              </Alert>
            </Col>
            <Col xs='5'>
              <div className='mb-2 font-weight-bold'>Enter your biography below</div>
              <CKEditor
                editor={ClassicEditor}
                data={bio}
                config={{
                  toolbar: ['heading', '|', 'bold', 'bulletedList'],
                  heading: {
                    options: [
                      { model: 'heading4', view: 'h5', title: 'Title', class: 'ck-heading_heading5' },
                      { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                    ]
                  }
                }}
                onReady={editor => {
                  editor.editing.view.change((writer) => {
                    writer.setStyle(
                      "height",
                      "360px",
                      editor.editing.view.document.getRoot()
                    );
                  });
                  document.getElementById('bio-preview').innerHTML = bio
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  document.getElementById('bio-preview').innerHTML = data

                  setValue({ bio: data })
                }}
                onFocus={(event, editor) => {
                  //
                }}
              />
              <RenderValidateMessage errors={errors} field="content" />
            </Col>
            <Col>
              <div className='mb-2 font-weight-bold'>Preview</div>
              <Card >
                <Card.Body style={{ height: '25em', overflow: 'scroll' }}>
                  <div id='bio-preview'> </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className='justify-content-end mt-4'>
            <Col xs='2'>
              <Button block variant='outline-primary' onClick={stepBack}>Back</Button>
            </Col>
            <Col xs='3'>
              <Button block disabled={errors} variant={errors ? 'secondary' : 'success'} onClick={stepForward}>Next</Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  </Row>
}


